<template>
    <div class="small">
        <div class="row">
            <div class="col-12">
                <div class="d-flex flex-row align-items-center">
                    <div class="left">
                        <div class="badge vehicle-badge">
                            <!-- Plugin Hybrid -->
                            <i v-if="fuelTypeElectricOrPluginHybrid(quote.derivative.fuelTypeDescription)" class="icon-plug-in" />

                            <!-- Electric -->
                            <i v-if="fuelTypeElectric(quote.derivative.fuelTypeDescription)" class="icon-electric" />
                        </div>
                        <!-- Make -->
                        <h3 class="make text-truncate" v-if="quote.manufacturerName"><span>{{quote.manufacturerName}}</span>
                            {{ quote.modelName }}
                        </h3>
                    </div>
                    <div class="right">
                        <!-- Vehicle Spec -->
                        <div class="vehicle-spec d-flex flex-row align-items-center justify-content-end">
                            <span class="key">Monthly Net Cost</span>
                            <span class="value" v-if="quote.quote">£{{ quote.quote.details.periodNet }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "comparison-grid-small",
    props:[
        "quote"
    ],
    methods:{
    }
}
</script>

<style scoped>

</style>
